import React, { Component } from 'react';
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Modal = ({isActive, children}) => {

	const modal = {
		enter: {
			y: "-50%",
			opacity: 1,
			delay: 300,
			x: "-50%",
			transition: {
				y: { type: "spring", stiffness: 333, damping: 15 },
			},
		},
		exit: {
			y: "50%",
			x: "-50%",
			delay: 100,
			opacity: 0,
		},
	};

	const shade = {
		enter: { opacity: 1 },
		exit: { opacity: 0 },
	};

	if (typeof document !== "undefined") {
		if (isActive) {
			document.getElementsByTagName("body")[0].classList.add("modalOpen");
		} else {
			document
				.getElementsByTagName("body")[0]
				.classList.remove("modalOpen");
		}
	}

	return (
		<div className={`modal-wrapper ${isActive && "open"}`}>
			<AnimatePresence>
				{isActive && [
					// If animating more than one child, each needs a `key`
					<motion.div
						key="shade"
						className="shade"
						onClick={() => {
							close(false);
						}}
						initial="exit"
						animate="enter"
						exit="exit"
						variants={shade}
					/>,
					<motion.div
						key="modal"
						id="modalPopUp"
						className="popUp"
						initial="exit"
						animate="enter"
						exit="exit"
						variants={modal}
					>
						{ children }
					</motion.div>,
				]}
			</AnimatePresence>
		</div>
	);
};

export default Modal;